import {BsArrowUpRightCircleFill} from 'react-icons/bs';

/**
 * Composant qui permet d'afficher un bouton qui ouvre un nouvel onglet
 * @param {array} url - url du bouton
 */

export default function ButtonArrow ({url}) {

    return (
        <button className="button button-arrow">
            <a href={url} target="_blank">
                <BsArrowUpRightCircleFill />
            </a>
        </button>
    )
}